exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.filter-container[data-v-38afce44] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n.pagination-container[data-v-38afce44] {\n  margin-top: 16px;\n}\n", ""]);

// exports
